import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import {
    BridgeNotificationSetting,
    UpsertNotificationSettingRequest
} from "../../../models/bridge/bridge-notification.model";
import { BridgeBaseService } from "./bridge-base.service";

/**
 * Service for 4Bridge Notification Settings API
 */
@Injectable({
    providedIn: 'root'
})
export class BridgeNotificationService extends BridgeBaseService<BridgeNotificationSetting> {

    constructor(httpClient: HttpClient) {
        super(httpClient, 'notifications');
    }

    /**
     * Get notification settings for the current tenant
     */
    public getSettings(): Observable<BridgeNotificationSetting> {
        return this.httpClient
            .get<BridgeNotificationSetting>(`${this.baseUrl}/${this.endpoint}`)
            .pipe(
                catchError((error) => this.handleError(error))
            );
    }

    /**
     * Update notification settings
     */
    public updateSettings(request: UpsertNotificationSettingRequest): Observable<BridgeNotificationSetting> {
        return this.httpClient
            .put<BridgeNotificationSetting>(`${this.baseUrl}/${this.endpoint}`, request)
            .pipe(
                catchError((error) => this.handleError(error))
            );
    }

    /**
     * Test email notification
     */
    public testEmailNotification(email: string): Observable<any> {
        return this.httpClient
            .post(`${this.baseUrl}/${this.endpoint}/test-email`, { email })
            .pipe(
                catchError((error) => this.handleError(error))
            );
    }
}
